// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-actions-container {
    display: flex;
    justify-content: center;
    margin: 1rem auto;
    width: 100%;
}

.searchTab {
    font-size: 1rem;
}

.form-primary-buttons-container {
    display: flex;
    justify-content: center;
    width: 100%;
}

.form-actions-container > * {
    min-width: fit-content;
}

.form-actions-container > *:not(:last-child) {
    margin-right: 2rem;
}

.form-primary-buttons-container > button {
    margin: 0rem 0.5rem;
}

.min-width-18rem {
    min-width: 18rem !important;
}

.search-form-autocomplete-field {
    margin-left: 50%;
    transform: translateX(-50%);
}

.autocomplete-width-18rem {
    width: 18rem !important;
}

.search-form-headers-position {
    justify-self: center;
    align-items: center;
}

.search-by-card-picklist-field {
    width: 100%;
}

.search-container {
    padding-top: 0px !important;
    margin: 0 auto;
    text-align: center;
}

.search-container > * {
    padding-top: 2.5rem;
}

.search-container-simple > * {
    padding-top: 1rem;
}

@media (max-width: 768px) {
    .search-container > * {
        padding-top: 1rem;
    }
    .search-by-card-picklist-field {
        margin-bottom: 1rem;
    }
}

@media (max-width: 700px) {
    .autocomplete-width-18rem,
    .min-width-18rem {
        width: 100% !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/search/Search.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;;QAEI,sBAAsB;IAC1B;AACJ","sourcesContent":[".form-actions-container {\n    display: flex;\n    justify-content: center;\n    margin: 1rem auto;\n    width: 100%;\n}\n\n.searchTab {\n    font-size: 1rem;\n}\n\n.form-primary-buttons-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n\n.form-actions-container > * {\n    min-width: fit-content;\n}\n\n.form-actions-container > *:not(:last-child) {\n    margin-right: 2rem;\n}\n\n.form-primary-buttons-container > button {\n    margin: 0rem 0.5rem;\n}\n\n.min-width-18rem {\n    min-width: 18rem !important;\n}\n\n.search-form-autocomplete-field {\n    margin-left: 50%;\n    transform: translateX(-50%);\n}\n\n.autocomplete-width-18rem {\n    width: 18rem !important;\n}\n\n.search-form-headers-position {\n    justify-self: center;\n    align-items: center;\n}\n\n.search-by-card-picklist-field {\n    width: 100%;\n}\n\n.search-container {\n    padding-top: 0px !important;\n    margin: 0 auto;\n    text-align: center;\n}\n\n.search-container > * {\n    padding-top: 2.5rem;\n}\n\n.search-container-simple > * {\n    padding-top: 1rem;\n}\n\n@media (max-width: 768px) {\n    .search-container > * {\n        padding-top: 1rem;\n    }\n    .search-by-card-picklist-field {\n        margin-bottom: 1rem;\n    }\n}\n\n@media (max-width: 700px) {\n    .autocomplete-width-18rem,\n    .min-width-18rem {\n        width: 100% !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
